import { render } from "./ThemeContentSnippet.vue?vue&type=template&id=3c58d37e"
import script from "./ThemeContentSnippet.vue?vue&type=script&lang=js"
export * from "./ThemeContentSnippet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__